import * as React from 'react';
import * as Redux from 'react-redux';
import { Grid, Paper } from '@mui/material';
import ListadoTiposActividadesExtcur from './components/ListadoTiposActividadesExtcur';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import {
  allTiposActividadesExtcurAction,
  setActivoTiposActividadesExtcurAction,
} from './TiposActividadesExtcurAction';
import FormTiposActividadesExtcur from './components/FormTiposActividadesExtcur';

const TiposActividadesExtcurView = () => {
  const dispatch = Redux.useDispatch();

  const tiposActividadesExtcurStore = Redux.useSelector(
    (state) => state.tiposActividadesExtcur,
  );

  const [isDelete, setIsDelete] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonComponent
          click={async () => {
            await setActivoTiposActividadesExtcurAction(dispatch, null);
            await allTiposActividadesExtcurAction(
              dispatch,
              tiposActividadesExtcurStore.params,
            );
          }}
          disabled={
            tiposActividadesExtcurStore.loadingAll ||
            tiposActividadesExtcurStore.all.length === 0
          }
          white
          refreshIcon
          text={
            tiposActividadesExtcurStore.loadingAll
              ? 'Actualizando...'
              : 'Actualizar'
          }
        />
      </Grid>
      <Grid item md={4}>
        <Paper elevation={5} sx={{ pb: 1 }}>
          <FormTiposActividadesExtcur isDelete={isDelete} />
        </Paper>
      </Grid>
      <Grid item md={8}>
        <ListadoTiposActividadesExtcur
          isDelete={isDelete}
          setIsDelete={(v) => setIsDelete(v)}
        />
      </Grid>
    </Grid>
  );
};

export default TiposActividadesExtcurView;
